import { useNavigate } from "react-router-dom";
import { Avatar, Menu, MenuItem, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

export default function AccountPop() {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(10);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserRole(decodedToken.role);
      } catch (e) {}
    }
  }, [token]);

  const handleLogout = () => {
    localStorage.clear();
    handleMenuClose();
    navigate("/admin/login");
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    if (userRole < 2) {
      navigate("/admin/portal");
    } else {
      navigate("/parents/portal");
    }
    handleMenuClose();
  };

  if (!token) return null;

  return (
    <>
      <IconButton onClick={handleMenuOpen} sx={{ p: 0, ml: 1 }}>
        <Avatar sx={{ bgcolor: "primary.main", width: 38, height: 38 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 3,
          sx: { mt: 1, minWidth: 150, borderRadius: 2 },
        }}
      >
        <MenuItem onClick={handleProfileClick}>My Profile</MenuItem>
        <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
